// @ts-nocheck
 
/* eslint-disable react/no-unknown-property */
 
 
 
/* eslint-disable padding-line-between-statements, import/order, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
 
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { log } from 'console';
import OrgComTypTable from './components/orgComTypTable';
import { useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';

const EditMerchantPOS = () => {
  const currentLanguageCode = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const intl = useIntl();
  const history = useHistory();
  const { id } = useParams();
  const query = new URLSearchParams(history.location.search);
  const came_from = query.get('came_from'); // Get "id" parameter
  console.log(came_from);
  // State variables
  const [merchent_ID, setMerchantId] = useState(null);
  const [commission_type_id, setCommission_type_id] = useState(null);
  const [merchants, setMerchants] = useState([]);
  const [commissionTypes, setCommissionTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [pos_user_name, setPosUserName] = useState('');
  const [pos_name, setPosName] = useState('');
  const [pos_pass, setPosPass] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pos_serial_number, setPosSerialNumber] = useState('');
  const [sam_UID, setSamUID] = useState('');
  const [sim_MSIDN, setSimMSIDN] = useState('');
  const [pos_user_limit, setUserLimit] = useState('');
  const [merchant_pos_status, setMerchantPosStatus] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMerchantsDataLoading, setIsMerchantsDataLoading] = useState(false);
  const [isCommissionTypesDataLoading, setIsCommissionTypesDataLoading] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

/*********************  start organisation commission type states  ******************** */
  const [com_type_ar_name, setCom_type_ar_name] = useState('');
  const [com_type_en_name, setCom_type_en_name] = useState('');
  const [isMultiOrg, setIsMultiOrg] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [organisationCommissionTypes, setOrganisationCommissionTypes] = useState([]);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [remove_organisation_commission_typeResponse, setRemove_organisation_commission_typeResponse] = useState(null);
  const [isAddingRow, setIsAddingRow] = useState(false); // State to toggle the input row
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownLoading, setDropdownLoading] = useState(true);
  const [formData, setFormData] = useState({
    ORGANISATION_ID: "",
    commission_type_id: "",
    COM_PROV: "",
    COM_RET: "",
    FLAT_FEE: "",
    VAT: "",
  });
  const [com_type_is_multi, setCom_type_is_multi] = useState(true);
  const [editingRowId, setEditingRowId] = useState(null); // Track the row being edited
  const [editFormData, setEditFormData] = useState({
    ORGANISATION_ID: "",
    COM_PROV: "",
    COM_RET: "",
    FLAT_FEE: "",
    VAT: "",
  });
/*********************  end organisation commission type states  ******************** */

  let userPersonalData = '';
  let userAuthData = '';
  const authData = localStorage.getItem('authData');

  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    userPersonalData = parsedAuthData.userData;
    userAuthData = parsedAuthData.userToken;
  }

  const fetchMerchantPOS = async () => {
    setIsFormLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/getMerchantPOS`;
      const response = await axios.post(
        url,
        { PersonID: id },
        {
          headers: {
            'access-token': userAuthData?.access_token,
            uid: userAuthData?.uid,
            client: userAuthData?.client,
          },
        }
      );
      const merchantPOS = response.data.data;
      setPosName(merchantPOS.email);
      setPosPass(merchantPOS.pass);
      setPosSerialNumber(merchantPOS.pos_serial_number);
      setSamUID(merchantPOS.sam_uid);
      setSimMSIDN(merchantPOS.sim_msidn);
      setMerchantId(merchantPOS.merchent_id);
      setCommission_type_id(merchantPOS.commission_type_id);
      setPosUserName(merchantPOS.user_name);
      setUserLimit(merchantPOS.user_limit);
      setMerchantPosStatus(merchantPOS.status);
    } catch (error) {
      setError(`Failed to fetch merchant POS [${error}]`);
      toast.error(`Failed to fetch merchant POS [${error}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsFormLoading(false);
    }
  };

  const fetchStatuses = async () => {
    setIsStatusLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchants/getStatus`;
      const response = await axios.get(url);
      setStatuses(response.data.data);
    } catch (error) {
      setError(`Failed to get Status [${error}]`);
      toast.error(`Failed to get Status [${error}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsStatusLoading(false);
    }
  };

  const fetchMerchants = async () => {
    setIsMerchantsDataLoading(true);
    setError(null);
    const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchants/getAllMerchants?status=1&page=1&pageSize=230`;
    try {
      const response = await axios.get(url, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setMerchants(response.data.data.result || []);
    } catch (error) {
      console.log('API ERROR', error);
      toast.error(`Sorry, ${error}. Please try again later or refresh the page. Code: #r1`, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsMerchantsDataLoading(false);
    }
  };
  const fetchCommissionTypes = async () => {
    setIsCommissionTypesDataLoading(true);
    setError(null);
    const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/get_commission_types`;
    try {
      const response = await axios.get(url, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setCommissionTypes(response.data.data || []);
  
    } catch (error) {
      console.log('API ERROR', error);
      toast.error(`Sorry, ${error}. Please try again later or refresh the page. Code: #r1`, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsCommissionTypesDataLoading(false);
    }
  };
  useEffect(() => {
    fetchStatuses();
    fetchMerchants();
    fetchCommissionTypes();
    fetchMerchantPOS();

  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check if userLimit is greater than 0
    if (pos_user_limit < 1) {
      setError(currentLanguageCode === 'en-us' ? `Limit should be greater than 0` : `الحد المسموح يجب أن يكون أكبر من 0`);
      toast.error(currentLanguageCode === 'en-us' ? `Limit should be greater than 0` : `الحد المسموح يجب أن يكون أكبر من 0`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
      return;
    }

    setIsLoading(true);
    setError(null);

    try {

      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/updateMerchantPOS`;
      const response = await axios.post(
        url,
        {
          Email: pos_name.trim(),
          Pass: pos_pass.trim(),
          pos_Serial_number: pos_serial_number.trim(),
          sam_UID: sam_UID.trim(),
          sim_MSIDN: sim_MSIDN.trim(),
          merchent_ID: merchent_ID,
          USER_NAME: pos_user_name.trim(),
          USER_LIMIT: pos_user_limit,
          STATUS: merchant_pos_status,
          commission_type_id: commission_type_id,
          PersonID: id
        },
        {
          headers: {
            'access-token': userAuthData?.access_token,
            uid: userAuthData?.uid,
            client: userAuthData?.client,
          },
        }
      );

      toast.success('Merchant POS updated successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        toastStyle: {
          backgroundColor: '#F1662D',
          color: 'white',
        },
      });
      history.push(came_from && came_from == "one"
        ? `/CardsManagement/merchantPOS/${id}` :
        `/CardsManagement/merchantPOS/`
      )
      /*setTimeout(() => {
        history.push('/CardsManagement/merchantPOS/');
      }, 500); */

    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        if (String(error.response.data.message).includes("merchant_pos_user_name_key")) {
          setError(currentLanguageCode == 'en-us' ? `POS Name Is Already Exist` : `اسم الجهاز موجود من قبل`);
          toast.error(currentLanguageCode == 'en-us' ? `POS Name Is Already Exist` : `اسم الجهاز موجود من قبل`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        } else if (String(error.response.data.message).includes("unique")) {
          setError(currentLanguageCode == 'en-us' ? `You Are Trying Enter Data already Exist` : `تم ادخال هذة البيانات من قبل`);
          toast.error(currentLanguageCode == 'en-us' ? `You Are Trying Enter Data already Exist` : `تم ادخال هذة البيانات من قبل`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        } else {
          setError(error.response.data.message);
          toast.error(`[${error.response.data.message}]`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        }
      } else {
        setError(`[${error}]`);
        toast.error(`[${error}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {

let call = async ()=>{
 
  const matchedCommissionType = commissionTypes.find(
    (item) => item.com_id === commission_type_id
  );
  setCom_type_en_name(matchedCommissionType?.com_en_name);
  setCom_type_ar_name(matchedCommissionType?.com_ar_name);
  setCom_type_is_multi(matchedCommissionType?.is_multi)

}
commissionTypes && commission_type_id &&  call();


  }, [commissionTypes,commission_type_id]);
/*********************  start organisation commission type functions ********************  */
useEffect(() => {
  const get_organisations_commission_types = () => {
    const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/get_organisations_commission_types`;

    setIsLoading(true);

    axios.post(url, {
      UUID_VALUE: commission_type_id
    }, {
      headers: {
        'access-token': userAuthData?.access_token,
        'uid': userAuthData?.uid,
        'client': userAuthData?.client,
      }
    })
      .then((res) => {
        setOrganisationCommissionTypes(res.data.data);
        if (res.data.data.length == 0) {

          setIsEnabled(true);
        } else if (res.data.data.length > 0) {

          if (isMultiOrg) {
            setIsEnabled(true);
          } else {
            setIsEnabled(false);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("API ERROR", err);
        toast.error(`Sorry, ${err.message}. Please try again later.`);
        setIsLoading(false);
      });
  };

  commission_type_id && get_organisations_commission_types();
}, [commission_type_id, message, remove_organisation_commission_typeResponse]);

//handle change for the input fields in add row
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};
const handleAddRow = () => {
  setIsAddingRow(true);
};

const handleCancelAddRow = () => {
  setIsAddingRow(false);
  setFormData({
    ORGANISATION_ID: "",
    commission_type_id: "",
    COM_PROV: "",
    COM_RET: "",
    FLAT_FEE: "",
    VAT: "",
  });
};

// Load organisations 
useEffect(() => {
  const fetchOrganisations = async () => {
    try {
      const res = await
        axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/fareMedia/get_organisations`, {
          headers: {
            'access-token': userAuthData?.access_token,
            'uid': userAuthData?.uid,
            'client': userAuthData?.client,
          }
        })

      setOrganisations(res.data.data || []);

    } catch (err) {
      console.error("API ERROR", err);
      toast.error(`Sorry, ${err.message}. Please try again later.`);
    } finally {
      setDropdownLoading(false);
    }
  };

  fetchOrganisations();
}, []);

//ADDING NEW ROW IN THE TABLE
const handleAddNewRow = async (e) => {
  e.preventDefault();

  if (formData.ORGANISATION_ID === "" ||
    formData.COM_PROV === "" ||
    formData.COM_RET === "" ||
    formData.FLAT_FEE === "" ||
    formData.VAT === "") {
    setError("Please fill in all fields.");
    toast.error("Please fill in all fields.");
    return;
  }
  setLoading(true);
  formData.commission_type_id = commission_type_id; // Ensure the commission_type_id is set in formData

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/add_organisation_commission_type`,
      formData,
      {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      }
    );

    setMessage({ type: "success", text: "added successfully" });
    toast.success("added successfully");

    // Close the adding row
    handleCancelAddRow();


    // setOrganisationCommissionTypes(updatedResponse.data.data || []);

  } catch (err) {
    console.error("API ERROR", err);
    toast.error(`${err.message}. Please try again later.`);
  } finally {
    setLoading(false);
  }
};

const handleEditFormChange = (e) => {
  const { name, value } = e.target;
  setEditFormData((prev) => ({ ...prev, [name]: value }));
};

const handleEditRow = (row) => {
  setEditingRowId(row.org_com_id); // Set the row ID being edited
  setEditFormData({
    ORGANISATION_ID: row.org_id,
    COM_PROV: row.com_prov,
    COM_RET: row.com_ret,
    FLAT_FEE: row.flat_fee,
    VAT: row.vat,
  });
};

const handleCancelEditRow = () => {
  setEditingRowId(null); // Exit edit mode
  setEditFormData({
    ORGANISATION_ID: "",
    COM_PROV: "",
    COM_RET: "",
    FLAT_FEE: "",
    VAT: "",
  });
};

const handleSaveEditRow = async () => {
  if (
    editFormData.COM_PROV === "" ||
    editFormData.COM_RET === "" ||
    editFormData.FLAT_FEE === "" ||
    editFormData.VAT === "" ||
    editFormData.ORGANISATION_ID === ""
  ) {
    toast.error("Please fill in all fields.");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/update_organisation_commission_type`,
      {
        COM_PROV: editFormData.COM_PROV,
        COM_RET: editFormData.COM_RET,
        FLAT_FEE: editFormData.FLAT_FEE,
        VAT: editFormData.VAT,
        organisation_commission_type_id: editingRowId,
        ORGANISATION_ID: editFormData.ORGANISATION_ID
      },
      {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      }
    );
    setMessage({ type: "success", text: "updated successfully" });
    toast.success("updated successfully");
    setEditingRowId(null); // Exit edit mode
    setEditFormData({
      ORGANISATION_ID: "",
      COM_PROV: "",
      COM_RET: "",
      FLAT_FEE: "",
      VAT: "",
    });
    //setOrganisationCommissionTypes(updatedResponse.data.data || []);
  } catch (err) {
    console.error("API ERROR", err);
    toast.error(`${err.message}. Please try again later.`);
  } finally {
    setLoading(false);
  }
};
const hasCommissionsWriteAccess = useTypedSelector(state =>
  hasWriteAccessToMasterConfigSubSystem(state, 'Commissions')
);

const remove_organisation_commission_type = async (organisation_commission_type_id) => {
  setIsLoading(true);
  try {
    let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/remove_organisation_commission_type`;
    const response = await axios.post(url, {

      organisation_commission_type_id: organisation_commission_type_id
    }, {
      headers: {
        'access-token': userAuthData?.access_token,
        'uid': userAuthData?.uid,
        'client': userAuthData?.client,
      },
    });
    setRemove_organisation_commission_typeResponse(response.data)
    toast.success('deleted successfully!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      toastStyle: {
        backgroundColor: '#F1662D',
        color: 'white',
      },
    });


  } catch (error) {
    if (error && error.response && error.response.data && error.response.data.message) {

      toast.error(`[${error.response.data.message}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } else {

      toast.error(`[${error}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    }
  } finally {
    setIsLoading(false);
  }
};
/*********************  end organisation commission type functions  ******************** */

  return (
    <>
      <Box sx={{ marginTop: -5, padding: 4 }}>
        <Typography sx={{ color: '#252733', fontWeight: 'bold', marginBottom: '16px' }}>
          {intl.formatMessage({ id: 'EditMerchantPOS' })}
        </Typography>

        {isFormLoading ? (
          <CircularProgress style={{ display: "block" }} />
        ) : (
          <Box component="form" onSubmit={handleSubmit}>
            <div className='parent-form'>
              <div>
                <label className='labelStyle'>{intl.formatMessage({ id: 'Name' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="email"
                  value={pos_name}
                  onChange={(e) => setPosName(e.target.value)}
                  required
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'POSName' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="username"
                  value={pos_user_name}
                  onChange={(e) => setPosUserName(e.target.value)}
                  required
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'Password' })}</label>
                <div className="inputPasswordContainer">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className='inputStylePassword'
                    id="password"
                    value={pos_pass}
                    onChange={(e) => setPosPass(e.target.value)}
                    required
                  />
                  <IconButton
                    className='visibIcon'
                    onClick={() => setShowPassword(!showPassword)}
                    style={currentLanguageCode === "en-us" ? { right: "33px" } : { left: "33px" }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </div>

                <label className='labelStyle'>{intl.formatMessage({ id: 'SelectMerchant' })}</label>
                {isMerchantsDataLoading ? (
                  <CircularProgress size={24} sx={{ display: "block" }} />
                ) : (
                  <select
                    className='inputStyle'
                    id="merchantSelect"
                    value={merchent_ID}
                    onChange={(e) => setMerchantId(e.target.value)}
                    required
                  >
                    {merchants.map((merchant) => (
                      <option key={merchant.merchant_id} value={merchant.merchant_id}>
                        {currentLanguageCode === "en-us" ? merchant.merchant_en_name : merchant.merchant_name}
                      </option>
                    ))}
                  </select>
                )}
       
                    <label className='labelStyle'>{intl.formatMessage({ id: 'SelectCommission_type' })}</label>

{isCommissionTypesDataLoading ? (

  <CircularProgress size={24} sx={{ display: "block" }} />

) : (<select
  className='inputStyle'
  id="commission_typeSelect"
  value={commission_type_id}
  onChange={
    (e) => {
      setFormData({
        ORGANISATION_ID: "",
        commission_type_id: "",
        COM_PROV: "",
        COM_RET: "",
        FLAT_FEE: "",
        VAT: "",
      });
      setIsAddingRow(false);
      const selectedId = e.target.value;
      setCommission_type_id(selectedId);

      // Find the selected commission type and set its names
      const selectedCommissionType = commissionTypes.find((com) => com.com_id === selectedId);
      if (selectedCommissionType) {
        setCom_type_en_name(selectedCommissionType.com_en_name);
        setCom_type_ar_name(selectedCommissionType.com_ar_name);
        //
        setCom_type_is_multi(selectedCommissionType.is_multi);
      }
    }
  
  }
  required

>
  {commission_type_id == null && <option value="" style={{ fontWeight: "bold" }}>{intl.formatMessage({ id: 'SelectCommission_type' })}</option>}
  {commissionTypes.map((com) => (
    <option key={com.com_id} value={com.com_id}>
    {currentLanguageCode == "en-us" ? com.com_en_name : com.com_ar_name} {"  -  "}
    {com.is_multi ? intl.formatMessage({ id: 'allowed_multi_org' }) : intl.formatMessage({ id: 'not_allowed_multi_org' })}
  </option>
  ))}

</select>)}
              </div>
              <div>
            
                <label className='labelStyle'>{intl.formatMessage({ id: 'POSSerialNumber' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="posSerialNumber"
                  value={pos_serial_number}
                  onChange={(e) => setPosSerialNumber(e.target.value)}
                  required
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'SAM UID' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="samUID"
                  value={sam_UID}
                  onChange={(e) => setSamUID(e.target.value)}
                  required
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'SIM MSIDN' })}</label>
                <input
                  type="text"
                  className='inputStyle'
                  id="simMSIDN"
                  value={sim_MSIDN}
                  onChange={(e) => setSimMSIDN(e.target.value)}
                  required
                />

                <label className='labelStyle'>{intl.formatMessage({ id: 'UserLimit' })}</label>
                <input
                  type="number"
                  className='inputStyle'
                  id="userLimit"
                  value={pos_user_limit}
                  onChange={(e) => setUserLimit(e.target.value)}
                  required
                  min="1"
                />

<label className='labelStyle'>{intl.formatMessage({ id: 'MerchantStatus' })}</label>
                {isStatusLoading ? (
                  <CircularProgress size={24} sx={{ display: "block" }} />
                ) : (
                  <select
                    className='inputStyle'
                    id="merchantStatus"
                    value={merchant_pos_status}
                    onChange={(e) => setMerchantPosStatus(e.target.value)}
                    required
                  >
                    {
                      statuses.map((status) => (
                        <option key={status.status_id} value={status.status_id}>
                          {currentLanguageCode === 'en-us' ? status.status_en_name : status.status}
                        </option>
                      ))
                    }
                  </select>
                )}

              </div>
            </div>
            {/* start organisation commission type section  */}
            <OrgComTypTable
              //  states values
              commission_type_id={commission_type_id}
              isLoading={isLoading}
              organisationCommissionTypes={organisationCommissionTypes}
              hasCommissionsWriteAccess={hasCommissionsWriteAccess}
              editingRowId={editingRowId}
              editFormData={editFormData}
              organisations={organisations}
              isAddingRow={isAddingRow}
              com_type_is_multi={com_type_is_multi}
              formData={formData}
              com_type_en_name={com_type_en_name}
              com_type_ar_name={com_type_ar_name}
              //states setters
              setIsLoading={setIsLoading}
              setOrganisationCommissionTypes={setOrganisationCommissionTypes}
              setEditFormData={setEditFormData}
              setFormData={setFormData}
              setCom_type_is_multi={setCom_type_is_multi}
              setCom_type_ar_name={setCom_type_ar_name}
              setCom_type_en_name={setCom_type_en_name}
              //functions 
              handleEditFormChange={handleEditFormChange}
              handleSaveEditRow={handleSaveEditRow}
              handleCancelEditRow={handleCancelEditRow}
              handleEditRow={handleEditRow}
              handleChange={handleChange}
              handleAddNewRow={handleAddNewRow}
              handleCancelAddRow={handleCancelAddRow}
              handleAddRow={handleAddRow}
              remove_organisation_commission_type={remove_organisation_commission_type}
            />
            {/* end organisation commission type section  */}



            <div sx={{ marginBottom: 2, display: "block" }}>
              <button
                type="submit"
                className='updateBtnStyle'
                disabled={isLoading}
              >
                {isLoading ? intl.formatMessage({ id: 'Updating' }) : intl.formatMessage({ id: 'update' })}
              </button>
              <button
                className='cancelBtnStyle'
                onClick={() => history.push(came_from && came_from == "one"
                  ? `/CardsManagement/merchantPOS/${id}` :
                  `/CardsManagement/merchantPOS/`
                )}
              >
                {intl.formatMessage({ id: 'Back' })}
              </button>
            </div>
          </Box>
        )}
      </Box>
      <ToastContainer />
    </>
  );
};

export default EditMerchantPOS;
